import React from 'react'
// libs
import { useQuery } from '@apollo/client/react'
// graphql
import { POSITIONS_TREE_QUERY } from 'graphql/position/queries'
// types
import { TRefetch } from 'types/refetch'
import { NetworkStatus } from '@apollo/client'
import { IPosition, IPositionsResponse, IPositionsQueryArgs } from 'types/graphql'
// utils
import get from 'lodash/get'
import { getOr, maxBy, pipe } from 'lodash/fp'

type Props = React.PropsWithChildren<unknown>

type QueryResponse = {
  positions: IPositionsResponse
}

interface IContext {
  refetch: TRefetch<QueryResponse, IPositionsQueryArgs>
  positions: IPosition[]
  isLoading: boolean
  lastPosition: number
}

export const PositionsAPIContext = React.createContext<IContext>({} as any)

const PositionsAPI: React.FC<Props> = ({ children }) => {
  const {
    data: treeQuery,
    loading,
    refetch,
    networkStatus
  } = useQuery<QueryResponse>(POSITIONS_TREE_QUERY, {
    variables: {
      pagination: {
        pageSkip: 0,
        pageTake: 10000
      }
    }
  })

  const positions: IPosition[] = (get(treeQuery, 'positions.data') || []).map((position) => ({
    ...position,
    title: position.description,
    assignee: position.user
  }))

  // @ts-ignore
  const lastPosition = pipe(maxBy('position'), getOr(0, 'position'))(positions)

  const value = {
    refetch,
    positions,
    lastPosition,
    isLoading: loading && networkStatus === NetworkStatus.loading
  }

  return <PositionsAPIContext.Provider value={value}>{children}</PositionsAPIContext.Provider>
}

export default PositionsAPI
